const ALLOWED_VIDEO_HOSTS = [
    "www.youtube.com",
    "youtube.com",
    "youtu.be",
    "www.youtube-nocookie.com",
    "player.vimeo.com",
    "vimeo.com",
];

export function isTrustedVideoUrl(url: string): boolean {
    try {
        const parsed = new URL(url);
        return parsed.protocol === "https:" && ALLOWED_VIDEO_HOSTS.includes(parsed.hostname);
    } catch {
        return false;
    }
}
